import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-135">
      {/* Angled top divider */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-brand-darker" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0 100%)'
    }} data-id="element-136" />

      <div className="relative z-10 max-w-3xl mx-auto px-4" data-id="element-137">
        <SectionReveal data-id="element-138">
          <p className="text-4xl mb-4 text-center" data-id="element-139">💣</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-10 uppercase" data-id="element-140">
            Todos los meses pasa lo mismo…
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-141">
          <div className="space-y-6 text-center mb-12" data-id="element-142">
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed" data-id="element-143">
              Pagás la factura… y sentís que algo no cierra.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed" data-id="element-144">
              Pero lo peor no es eso.
            </p>
            <p className="text-xl sm:text-2xl text-brand-gold font-body font-bold leading-relaxed" data-id="element-145">
              👉 Lo peor es que probablemente estás perdiendo plata sin darte
              cuenta.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-146">
          <div className="space-y-4 mb-12" data-id="element-147">
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-148">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-149" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-150">
                Aparatos que consumen aunque no los uses
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-151">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-152" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-153">
                Errores comunes que inflan tu factura
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-154">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-155" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-156">
                Subsidios mal aplicados o mal configurados
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-red/10 border border-brand-red/20 rounded-lg p-4" data-id="element-157">
              <AlertTriangleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-158" />
              <p className="text-gray-200 font-body text-base sm:text-lg m-0" data-id="element-159">
                Hábitos que parecen normales… pero te cuestan miles
              </p>
            </div>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-160">
          <p className="text-xl sm:text-2xl text-gray-400 font-body text-center mb-12 italic" data-id="element-161">
            Y nadie te lo explica claro.
          </p>
        </SectionReveal>

        <SectionReveal delay={0.4} data-id="element-162">
          <div className="text-center" data-id="element-163">
            <CTAButton text="QUIERO PAGAR MENOS YA" scrollTo="oferta" size="lg" data-id="element-164" />
          </div>
        </SectionReveal>
      </div>
    </section>;
}